<template>
  <div class="btn-round__tooltip">
    <a class="btn--option" @click="print()">
      <i class="glicon-f-print"></i>
      <Tooltip :text="'tables.printBtn'"></Tooltip>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Tooltip from './Tooltip';

export default {
  name: 'PrintBtn',
  components: {
    Tooltip
  },
  computed: {
    ...mapState({
      admin: (state) => state.admins.admin
    })
  },
  methods: {
    print() {
      window.print();
    }
  }
};
</script>
